module.exports = __webpack_public_path__ + "img/407-9af29e.png";